/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useMemo } from 'react';
import { MediaCardError } from '../../errors';
import { useResolveSvg, MediaSVGError } from '@atlaskit/media-svg';
import { ImageRenderer } from '../ui/imageRenderer/imageRendererV2';
var getErrorReason = function getErrorReason(svgReason) {
  switch (svgReason) {
    case 'img-error':
      return 'svg-img-error';
    case 'binary-fetch':
      return 'svg-binary-fetch';
    case 'blob-to-datauri':
      return 'svg-blob-to-datauri';
    default:
      return 'svg-unknown-error';
  }
};
export var SvgView = function SvgView(_ref) {
  var identifier = _ref.identifier,
    resizeMode = _ref.resizeMode,
    onLoad = _ref.onLoad,
    onError = _ref.onError,
    wrapperRef = _ref.wrapperRef,
    alt = _ref.alt;
  var onSvgError = function onSvgError(err) {
    var error = new MediaCardError(getErrorReason(err.primaryReason), err.secondaryError);
    onError === null || onError === void 0 || onError(error);
  };
  var _useResolveSvg = useResolveSvg(identifier, onSvgError),
    svgUrl = _useResolveSvg.svgUrl,
    source = _useResolveSvg.source;
  var cardPreview = useMemo(function () {
    return svgUrl && source ? {
      dataURI: svgUrl,
      source: source
    } : undefined;
  }, [svgUrl, source]);
  return cardPreview ? jsx(ImageRenderer, {
    testId: "media-card-svg",
    identifier: identifier,
    cardPreview: cardPreview,
    alt: alt,
    resizeMode: resizeMode,
    onImageLoad: onLoad,
    onImageError: function onImageError() {
      onSvgError(new MediaSVGError('img-error'));
    },
    wrapperRef: wrapperRef,
    mediaType: "image",
    useWhiteBackground: true
  }) : null;
};